/**
 * Created by mark on 17/12/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';
var _registerToActions = function(action){

    switch(action.actionType)
    {
        case Constants.GET_GRADABLE_QUESTIONS:
            this.gradableQuestions = (action.response)
            this.emit(Constants.GET_GRADABLE_QUESTIONS);
            break;

        case Constants.GET_ASSIGNMENT_LIBRARY:
            this.assignmentLibrary = (action.response)
            this.emit(Constants.GET_ASSIGNMENT_LIBRARY);
            break;
        case Constants.GET_GRADED_QUESTIONS:
            this.gradedQuestions = (action.response)
            this.emit(Constants.GET_GRADED_QUESTIONS);
            break;
        case Constants.GET_USERS_COMPLETED:
            this.lastStudents = (action.response)
            this.emit(Constants.GET_USERS_COMPLETED);
            break;
    }

};
    
class AssignmentStore extends BaseStore{

    constructor(){
        super();
        this.subscribe(() => _registerToActions.bind(this));
        this.yearGroups =  [];
        this.productFeatures = [];
        this.curriculumData = [];
        this.activeAccountID = null;
    }

    getGradableQuestions() {
        return this.gradableQuestions || [];
    }

    getGradedQuestions() {
        return this.gradedQuestions  || [];
    }
}

export default new AssignmentStore();